import { EPIC_NAME } from 'core/constants/products'
import getById from 'utils/DOM/getById'
import getShoppingTip from '../../utils/getShoppingTip'
import getTemplate from '../../utils/getTemplate'
import renderShoppingTip from './renderShoppingTip'

const templateShoppingTip = getTemplate('template-shopping-tip')
const shoppingTipWrap = getById('shopping-tip-wrap')

function loadShoppingTip() {
  getShoppingTip().then(shoppingTip => {
    const tip = {
      message: shoppingTip.default.message,
      title: shoppingTip.default.title
    }
    renderShoppingTip(shoppingTipWrap, templateShoppingTip, tip)
  })
}

export default loadShoppingTip
